export default "__VITE_ASSET__EJ6slJ0Q__"